// extracted by mini-css-extract-plugin
export default {"productBorder":"Productlist_productBorder__xsLiX"};